<template>
    <form @submit.prevent="onClickSubmit">
        <div class="form-registration">
            <div
                v-for="(input, index) of inputs"
                :key="index"
                class="form-registration__item"
            >
                <input
                    :placeholder="input.placeholder"
                    v-model="input.value"
                />
            </div>
            <div class="form-registration__btn-container">
                <button
                    type="submit"
                    class="btn_default" 
                >
                    Зарегистрироваться
                </button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'FormRegistration',
    /**
     * Данные компонента
     * @property {array} inputs - инпуты
     */
    data: () => ({
        inputs: [
            {
                key: 'email',
                placeholder: 'Email',
                value: ''
            },
            {
                key: 'password',
                placeholder: 'Пароль',
                value: ''
            },
            {
                key: 'password_repeat',
                placeholder: 'Повторите пароль',
                value: ''
            },
            {
                key: 'company',
                placeholder: 'Название компании',
                value: ''
            },
            {
                key: 'name',
                placeholder: 'Имя',
                value: ''
            },
            {
                key: 'surname',
                placeholder: 'Фамилия',
                value: ''
            },
        ]
    }),
    computed: {
        /**
         * Данные формы
         * @returns {object}
         */
        formData() {
            let formData = {};
            this.inputs.forEach((input) => {
                formData[input.key] = input.value;
            });
            return formData;
        }
    },
    methods: {
        /**
         * событие отправки формы
         */
        onClickSubmit() {
            this.$emit("onClickSubmit", this.formData);
        }
    }
}
</script>

<style lang="scss" scoped>
    .form-registration {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
    }
    .form-registration__item {
        width: 48%;
        position: relative;
    }
    input {
        width: 100%;
        background: #fff;
        border: 1px solid #fff;
        outline: 0;
        height: 40px;
        padding: 0 10px;
        border-radius: 4px;
        font-size: 12px;
        margin: 0 10px 10px 0;
        font-weight: bold;
        transition: all 250ms;
        line-height: normal;
    }
    .form-registration__btn-container {
        width: 100%;
        text-align: right;
        margin-top: 20px;
    }
</style>